import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from '@mui/material';
import { RegisterRequestEmailInterface } from '../../RegisterUpload/types';

type Props = {
  isVisible: boolean;
  onClose: () => void;
  emails: RegisterRequestEmailInterface[];
};

export default function RegisterRequestEmailHistoryDialog({ isVisible, onClose, emails }: Props) {
  return (
    <Dialog open={isVisible} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle className="text-xl text-neutral-600 !font-bold">Kompletteringshistorik</DialogTitle>

      <DialogContent>
        <div className="flex flex-col gap-6">
          {emails.map((email, index) => (
            <div key={email.id}>
              <div className="flex justify-between gap-4 mb-4">
                <div>
                  <Typography variant="body2" className="!font-semibold">
                    {email.sender_name}
                  </Typography>

                  <Typography variant="body2" className="!text-neutral-500">
                    Till: {email.recipient}
                  </Typography>
                </div>

                <Typography variant="body2" className="!text-neutral-500">
                  {email.created_at}
                </Typography>
              </div>

              <Typography variant="body2" className="!text-sm whitespace-pre-wrap !leading-[1.1]">
                {email.message}
              </Typography>

              {index < emails.length - 1 && <Divider className="!mt-6" />}
            </div>
          ))}
        </div>
      </DialogContent>

      <DialogActions>
        <Button className="w-52 h-13" variant="outlined" color="error" onClick={onClose}>
          Stäng
        </Button>
      </DialogActions>
    </Dialog>
  );
}
